"use client"

import { cn } from "@/lib/utils"

interface ContentSectionProps {
  title: string
  content: string
  className?: string
}

export default function ContentSection({
  title,
  content,
  className,
}: ContentSectionProps) {
  // Debug logs for production debugging (remove after fixing React error #418)
  // Use console.warn instead of console.log to prevent minification removal
  if (typeof window !== "undefined") {
    console.warn("[ContentSection] Rendering:", {
      title,
      titleType: typeof title,
      contentLength: content?.length,
      contentType: typeof content,
      hasContent: !!content,
      contentPreview:
        typeof content === "string" ? content.substring(0, 100) : content,
    })
  }

  // Validate title is a string to prevent React error #418
  const sanitizedTitle =
    typeof title === "string" ? title : title ? String(title) : "Untitled"

  if (!content) return null

  // Validate and sanitize content to prevent hydration errors
  // Ensure content is always a string before using dangerouslySetInnerHTML
  const sanitizedContent =
    typeof content === "string" ? content : String(content || "")

  // Additional validation: check if content is empty after sanitization
  if (!sanitizedContent || sanitizedContent.trim().length === 0) {
    return null
  }

  return (
    <div className={cn("max-w-4xl mx-auto", className)}>
      <h2 className="text-2xl font-bold mb-3 text-foreground">
        {sanitizedTitle}
      </h2>
      <div
        className="text-muted-foreground prose prose-lg dark:prose-invert max-w-none prose-headings:text-foreground prose-p:text-muted-foreground prose-a:text-primary prose-strong:text-foreground"
        dangerouslySetInnerHTML={{ __html: sanitizedContent }}
      />
    </div>
  )
}
